// extracted by mini-css-extract-plugin
module.exports = {"chat":"_93444fe79c--chat--V3eyX"};